import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

/**
 * Uses the window object to get the search parameters if the params from `useSearchParams` turn out to be null.
 * See https://internal.jira.onedayonly.co.za/browse/FE-582 for more information on why this might occur.
 * This might no longer be necessary once we've upgraded Next.js.
 */

const useSearchParamsWithFallback = (param: string) => {
  const nextSearchParams = useSearchParams();
  const [searchParams, setSearchParams] = useState<string | null>(
    () => nextSearchParams?.get(param) || null
  );
  useEffect(() => {
    if (searchParams) {
      return;
    }
    const windowSearchParams = new URLSearchParams(window.location.search);
    const searchParamsObject = {};

    for (const [key, value] of windowSearchParams.entries()) {
      searchParamsObject[key] = value;
    }

    setSearchParams(searchParamsObject[param] || null);
  }, [nextSearchParams, param, searchParams]);

  return searchParams;
};

export default useSearchParamsWithFallback;
